import { resourceKeys } from '@aimmo/ui';
import { api, assertOk } from '../lib/api.js';
import { makeLookup } from '../lib/lookup.js';

/**
 * The pickers every property form and filter bar needs. Typed searches against
 * the API, never loaded lists — the same rule as the comune picker in M1.
 */
export const { search: searchTypologies, resolve: resolveTypology } = makeLookup({
  key: resourceKeys.all('property-typologies'),
  search: async (query, signal) =>
    assertOk(
      await api.propertyTypologies.list({
        // Categories are the leaves an asset is actually classified as; macro and
        // typology levels are the tree above it.
        query: {
          page: 1,
          pageSize: 20,
          order: 'asc',
          level: 'category',
          active: true,
          ...(query ? { q: query } : {}),
        },
        fetchOptions: { signal },
      }),
    ).body.items,
  get: async (id, signal) =>
    assertOk(await api.propertyTypologies.get({ params: { id }, fetchOptions: { signal } })).body,
  toOption: (item) => ({ value: item.id, label: item.breadcrumb.join(' › ') }),
});

export const { search: searchZones, resolve: resolveZone } = makeLookup({
  key: resourceKeys.all('zones'),
  search: async (query, signal) =>
    assertOk(
      await api.zones.list({
        query: { page: 1, pageSize: 20, order: 'asc', ...(query ? { q: query } : {}) },
        fetchOptions: { signal },
      }),
    ).body.items,
  get: async (id, signal) =>
    assertOk(await api.zones.get({ params: { id }, fetchOptions: { signal } })).body,
  toOption: (item) => ({ value: item.id, label: `${item.name} — ${item.comuneName}` }),
});

export const { search: searchBuildings, resolve: resolveBuilding } = makeLookup({
  key: resourceKeys.all('buildings'),
  search: async (query, signal) =>
    assertOk(
      await api.buildings.list({
        query: { page: 1, pageSize: 20, order: 'asc', ...(query ? { q: query } : {}) },
        fetchOptions: { signal },
      }),
    ).body.items,
  get: async (id, signal) =>
    assertOk(await api.buildings.get({ params: { id }, fetchOptions: { signal } })).body,
  toOption: (item) => ({ value: item.id, label: item.name }),
});
